import { Map } from 'immutable';

import {
  GET_TREATMENT_PAGE_SUCCESS,
  GET_TREATMENT_PAGE_ERROR,
  GET_TREATMENT_PAGE_START,
  TOGGLE_CHECKBOX_START,
  TOGGLE_CHECKBOX_SUCCESS,
  TOGGLE_CHECKBOX_ERROR,
  CLEAR_TOGGLE_CHECKBOX_ERROR,
  DOWNLOAD_TREATMENT_PRESCRIPTION_START,
  DOWNLOAD_TREATMENT_PRESCRIPTION_SUCCESS,
  DOWNLOAD_TREATMENT_PRESCRIPTION_ERROR,
  DOWNLOAD_TREATMENT_PRESCRIPTION_CLEAR,
  DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_START,
  DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_SUCCESS,
  DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_ERROR,
  CLEAR_DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN,
} from '../actions/treatmentPage';

const initialState = Map({
  data: null,
  error: null,
  loading: false,
  toggleCheckboxError: null,
  isCheckboxToggleSuccessful: false,
  downloadTreatmentPrescriptionData: null,
  downloadTreatmentPrescriptionError: null,
  downloadNutritionAdviceActionPlanData: null,
  downloadNutritionAdviceActionPlanError: null,
});

const actionsMap = {
  [GET_TREATMENT_PAGE_START]: (state, action) => {
    return state.merge(
      Map({
        error: null,
        loading: action.payload.isSilent ? false : true,
      }),
    );
  },
  [GET_TREATMENT_PAGE_SUCCESS]: (state, action) => {
    return state.merge(
      Map({
        data: action.data,
        loading: false,
      }),
    );
  },
  [GET_TREATMENT_PAGE_ERROR]: (state, action) => {
    return state.merge(
      Map({
        error: action.error,
        loading: false,
      }),
    );
  },
  [TOGGLE_CHECKBOX_START]: (state) => {
    return state.merge(
      Map({
        toggleCheckboxError: null,
      }),
    );
  },
  [TOGGLE_CHECKBOX_SUCCESS]: (state) => {
    return state.merge(
      Map({
        isCheckboxToggleSuccessful: true,
      }),
    );
  },
  [TOGGLE_CHECKBOX_ERROR]: (state, action) => {
    return state.merge(
      Map({
        toggleCheckboxError: action.error,
      }),
    );
  },
  [CLEAR_TOGGLE_CHECKBOX_ERROR]: (state) => {
    return state.merge(
      Map({
        toggleCheckboxError: null,
        isCheckboxToggleSuccessful: false,
      }),
    );
  },
  [DOWNLOAD_TREATMENT_PRESCRIPTION_START]: (state) => {
    return state.merge(
      Map({
        downloadTreatmentPrescriptionError: null,
      }),
    );
  },
  [DOWNLOAD_TREATMENT_PRESCRIPTION_SUCCESS]: (state, action) => {
    return state.merge(
      Map({
        downloadTreatmentPrescriptionData: {
          blob: action.data,
          stepId: action.stepId,
        },
      }),
    );
  },
  [DOWNLOAD_TREATMENT_PRESCRIPTION_ERROR]: (state, action) => {
    return state.merge(
      Map({
        downloadTreatmentPrescriptionError: action.error,
      }),
    );
  },
  [DOWNLOAD_TREATMENT_PRESCRIPTION_CLEAR]: (state) => {
    return state.merge(
      Map({
        downloadTreatmentPrescriptionError: null,
        downloadTreatmentPrescriptionData: null,
      }),
    );
  },
  [DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_START]: (state) => {
    return state.merge(
      Map({
        downloadNutritionAdviceActionPlanError: null,
      }),
    );
  },
  [DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_SUCCESS]: (state, action) => {
    return state.merge(
      Map({
        downloadNutritionAdviceActionPlanData: {
          blob: action.data,
          stepId: action.stepId,
          buttonType: action.buttonType,
        },
      }),
    );
  },
  [DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN_ERROR]: (state, action) => {
    return state.merge(
      Map({
        downloadNutritionAdviceActionPlanError: action.error,
        downloadNutritionAdviceActionPlanData: {
          stepId: action.stepId,
          buttonType: action.buttonType,
        },
      }),
    );
  },
  [CLEAR_DOWNLOAD_NUTRITION_ADVICE_ACTION_PLAN]: (state) => {
    return state.merge(
      Map({
        downloadNutritionAdviceActionPlanError: null,
        downloadNutritionAdviceActionPlanData: null,
      }),
    );
  },
};

export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
